import React from "react";
import Header from "../components/Header";
import Contact from "../components/homepage/Contact";
import { UseLangContext } from "../contexts/Lang";

type Props = {
  children: React.ReactNode;
};

const index = ({ children }: Props) => {
  const {
    t: { homepage },
  } = UseLangContext();
  return (
    <div className="max-w-[1600px] mx-auto relative">
      <Header />
      <section className="pb-8">{children}</section>
      {/* CONTACT US */}
      <section className="h-full" id="contact">
        <Contact lang={homepage} />
      </section>
    </div>
  );
};

export default index;
